"use strict";
exports.__esModule = true;
exports.ShareClass = void 0;
var ShareClass;
(function (ShareClass) {
    ShareClass["frontEndA"] = "frontEnd_A";
    ShareClass["retail"] = "retail";
    ShareClass["backEndB"] = "backEnd_B";
    ShareClass["levelLoadC"] = "levelLoad_C";
    ShareClass["levelLoadD"] = "levelLoad_D";
    ShareClass["institutional"] = "institutional";
    ShareClass["investor"] = "investor";
    ShareClass["frontEndM"] = "frontEnd_M";
    ShareClass["levelLoadN"] = "levelLoad_N";
    ShareClass["noLoad"] = "noLoad";
    ShareClass["other"] = "other";
    ShareClass["retirement"] = "retirement";
    ShareClass["noLoadS"] = "noLoad_S";
    ShareClass["frontEndT"] = "frontEnd_T";
    ShareClass["commonStock"] = "commonStock";
    ShareClass["classE"] = "class_E";
    ShareClass["retirementK"] = "retirement_K";
    ShareClass["adr"] = "adr";
    ShareClass["eqDivShr"] = "eqDivShr";
    ShareClass["limtVotingShr"] = "limtVotingShr";
    ShareClass["exchangableShr"] = "exchangableShr";
    ShareClass["multVotingShr"] = "multVotingShr";
    ShareClass["trustUnit"] = "trustUnit";
    ShareClass["privatePlacement"] = "privatePlacement";
    ShareClass["nonVotingShr"] = "nonVotingShr";
    ShareClass["subVotingShr"] = "subVotingShr";
    ShareClass["preferred"] = "preferred";
    ShareClass["capShare"] = "capShare";
    ShareClass["ordShr"] = "ordShr";
    ShareClass["cdi"] = "cdi";
    ShareClass["gdr"] = "gdr";
    ShareClass["savings"] = "savings";
    ShareClass["convSavings"] = "convSavings";
    ShareClass["privileged"] = "privileged";
    ShareClass["feesMgmtDist"] = "feesMgmtDist";
    ShareClass["feesMgmtOnly"] = "feedMgmtOnly";
    ShareClass["feesNone"] = "feesNone";
    ShareClass["loadWaived"] = "loadWaived";
    ShareClass["all"] = "all";
    ShareClass["undefined"] = "undefined";
})(ShareClass = exports.ShareClass || (exports.ShareClass = {}));
